import React from 'react';

import styles from './styles.module.css';

function GestorPosCloverPrivacy() {
	return (
		<section>
			<div className={styles.container}>
				<h1>Política de Privacidade para Gestor POS</h1>
				<p>
					<b>Data de entrada em vigor: 04/02/2026</b>
					<br></br>
					Esta “Política de Privacidade” explica como Brajan Sistemas (“ Empresa
					” ou “ nós ”) coleta, usa, divulga e processa dados pessoais em nome
					de nossos clientes - geralmente, comerciantes (qualquer um, um “
					Comerciante ”) - em relação ao nosso aplicativo, Gestor POS , que
					funciona no sistema de Ponto de Venda Clover (“ Clover POS ”). Esta
					Política de Privacidade não se aplica às práticas de privacidade da
					Empresa em nenhum outro contexto. O processamento de dados pessoais
					pela empresa em relação ao nosso aplicativo é regido por esta Política
					de Privacidade e pelos nossos contratos com os Comerciantes. Em caso
					de conflito entre esta Política de Privacidade e um contrato com o
					cliente, o contrato com o cliente prevalecerá na medida permitida pela
					legislação aplicável. Esta Política de Privacidade não substitui
					qualquer política de privacidade que um Comerciante possa ser obrigado
					a fornecer aos seus clientes, funcionários ou outros indivíduos.
				</p>

				<h2>Informações que a Clover coleta</h2>
				<p>
					Podemos coletar dados pessoais de ou em nome de Comerciantes. Os
					Comerciantes determinam o escopo dos dados pessoais que nos são
					transferidos ou que coletamos, e as informações que recebemos podem
					variar de acordo com o Comerciante. Normalmente, as informações que
					coletamos em nome dos Comerciantes incluem:
				</p>

				<h3>
					Informações que coletamos quando um cliente de um comerciante efetua
					um pagamento.
				</h3>
				<p>
					Quando um cliente efetua um pagamento através de um terminal de ponto
					de venda (PDV) Clover, coletamos informações sobre a transação, que
					podem incluir dados pessoais. As informações sobre as transações
					incluem o cartão de pagamento utilizado, o nome associado ao cartão de
					pagamento, a localização da loja do comerciante, a data e a hora da
					transação, o valor da transação e informações sobre os bens ou
					serviços adquiridos na transação.
				</p>
				<h5>
					Informações adicionais que os clientes do comerciante fornecem através
					do sistema de ponto de venda Clover, complementares a um pagamento.
				</h5>
				<p>
					Podemos coletar informações adicionais relacionadas ao pagamento.
					Essas informações podem incluir:
					<br></br>- Endereço de e-mail ou número de telefone do cliente, como
					quando o cliente opta por receber um recibo eletrônico.
					<br></br>- Preferências de marketing dos clientes, como por exemplo,
					se o cliente deseja receber comunicações de marketing ou newsletters.
					<br></br>- Informações sobre a atividade dos clientes participantes em
					um programa de fidelidade do estabelecimento.
					<br></br>- Endereço físico do cliente, quando necessário para a
					entrega de bens ou serviços.
					<br></br>- Outras informações fornecidas pelo cliente, como data de
					nascimento, interesses ou preferências, avaliações e comentários.
				</p>
				<h3>Informações que coletamos sobre o pessoal de um comerciante</h3>
				<p>
					Podemos coletar informações sobre os funcionários dos comerciantes e
					suas interações com o sistema de PDV Clover, como horário de entrada e
					saída e gorjetas recebidas.
				</p>
				<h5>
					Informações adicionais que os comerciantes nos fornecem sobre seus
					clientes ou funcionários.
				</h5>
				<p>
					Os comerciantes podem nos fornecer informações adicionais diretamente,
					por meio do acesso que nos concedem ou de outras formas. Os tipos de
					informações que os comerciantes podem nos fornecer sobre seus clientes
					incluem endereços de e-mail, números de telefone e histórico de
					compras. Os tipos de informações que os comerciantes podem nos
					fornecer sobre seus funcionários incluem endereços de e-mail, números
					de telefone, turnos e histórico de vendas.
				</p>
				<h2>Como utilizamos as informações que coletamos</h2>
				<p>
					Utilizamos os dados pessoais que coletamos para ou em nome dos
					Comerciantes, para fornecer nossos serviços e a funcionalidade de
					nosso aplicativo de gerenciamento de mesas e delivery para
					restaruantes e ponto de venda para varejos.
					<br></br>
					Também podemos usar dados pessoais para fins internos relacionados,
					incluindo:
					<br></br>- Para fornecer informações sobre o aplicativo, como
					atualizações ou alterações importantes e alertas de segurança.
					<br></br>- Para medir o desempenho e melhorar a aplicação.
					<br></br>- Para responder a perguntas, reclamações e solicitações de
					suporte ao cliente.
					<br></br>
					Além disso, a Empresa poderá usar dados pessoais conforme
					considerarmos necessário ou apropriado para (a) cumprir as leis
					aplicáveis e solicitações legais e processos judiciais, como responder
					a intimações ou solicitações de autoridades governamentais; (b) fazer
					cumprir os termos e condições que regem nosso aplicativo; (c) proteger
					nossos direitos, privacidade, segurança ou propriedade, e/ou os seus
					ou de terceiros; e (d) proteger, investigar e impedir atividades
					fraudulentas, prejudiciais, não autorizadas, antiéticas ou ilegais.
				</p>

				<h2>Como compartilhamos informações</h2>
				<p>
					Podemos compartilhar os dados pessoais que coletamos com:
					<br></br>- O comerciante de quem ou em nome de quem coletamos os dados
					pessoais A plataforma na qual nosso aplicativo é executado é o Clover
					POS.
					<br></br>- Você pode consultar a Política de Privacidade da Clover
					<a href="https://www.clover.com/privacy-policy">aqui.</a>
					<br></br>- Com terceiros, conforme instruções do comerciante.
					<br></br>- Com fornecedores de serviços terceirizados que nos ajudam a
					gerenciar e aprimorar o aplicativo.
					<br></br>- Com subsidiárias e afiliadas corporativas da Empresa para
					os fins descritos nesta Política de Privacidade ou em nosso contrato
					com um Comerciante.
					<br></br>A Empresa poderá divulgar dados pessoais a autoridades
					governamentais ou policiais ou a terceiros, conforme exigido por lei,
					e divulgar e usar tais informações conforme acreditarmos ser
					necessário ou apropriado para (a) cumprir as leis aplicáveis ​​e
					solicitações legais e processos judiciais, como responder a intimações
					ou solicitações de autoridades governamentais; (b) fazer cumprir os
					termos e condições que regem nosso aplicativo; (c) proteger nossos
					direitos, privacidade, segurança ou propriedade, e/ou os seus ou de
					terceiros; e (d) proteger, investigar e impedir atividades
					fraudulentas, prejudiciais, não autorizadas, antiéticas ou ilegais.
					<br></br>A empresa poderá vender ou transferir parte ou a totalidade
					de seus negócios ou ativos, incluindo seus dados pessoais, em conexão
					com uma transação comercial (ou potencial transação comercial), como
					uma fusão, consolidação, aquisição, reorganização ou venda de ativos,
					ou em caso de falência, situação em que envidaremos esforços razoáveis
					para exigir que o destinatário respeite esta Política de Privacidade.
				</p>

				<h2>Seus direitos e opções</h2>
				<h3>Direitos do titular dos dados</h3>
				<p>
					Na medida em que a legislação aplicável conceda aos indivíduos
					direitos relativos às suas informações pessoais, como o direito de
					revisar e solicitar alterações nessas informações, os indivíduos devem
					entrar em contato com o Comerciante para quaisquer solicitações
					referentes ao uso do nosso aplicativo pelo Comerciante. Caso a Clover
					seja responsável por responder às solicitações de direitos do titular
					dos dados de acordo com a legislação aplicável, os indivíduos podem
					entrar em contato com a Clover para as solicitações pertinentes,
					conforme explicado no Aviso de Privacidade da Clover, disponível em
					<a href="https://www.clover.com/privacy-policy">
						https://www.clover.com/privacy-policy
					</a>
					. A Empresa auxiliará o Comerciante, ou a Clover, conforme o caso, a
					responder a tais solicitações, sujeito ao nosso contrato com o
					Comerciante ou com a Clover.
				</p>

				<h3>Reclamações</h3>
				<p>
					Se tiver alguma reclamação sobre a forma como tratamos os seus dados
					pessoais, pode contactar-nos através das informações de contacto
					fornecidas abaixo.
				</p>

				<h3>Atualizações</h3>
				<p>
					Reservamo-nos o direito de modificar esta Política de Privacidade a
					qualquer momento. Notificaremos você sobre as atualizações, alterando
					a data desta Política de Privacidade.
				</p>

				<h2>Contate-nos</h2>
				<p>
					Você pode entrar em contato conosco para quaisquer dúvidas,
					comentários ou reclamações sobre esta Política de Privacidade ou
					nossas práticas de privacidade através do seguinte endereço de email:
					contato@brajan.com.br
				</p>
			</div>
		</section>
	);
}

export default GestorPosCloverPrivacy;
